/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_ListsInputs */

const en_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading lists...`)
};

const fr_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des listes...`)
};

const de_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade Listen...`)
};

const it_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento elenchi in corso...`)
};

const ru_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка списков...`)
};

const es_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando listas...`)
};

const zh_cn2_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载列表...`)
};

const ja_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストを読み込んでいます...`)
};

const hi_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचियाँ लोड हो रही हैं...`)
};

const pt_pt2_loading_lists = /** @type {(inputs: Loading_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando listas...`)
};

/**
* | output |
* | --- |
* | "Loading lists..." |
*
* @param {Loading_ListsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_lists = /** @type {((inputs?: Loading_ListsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_ListsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_loading_lists(inputs)
	if (locale === "de") return de_loading_lists(inputs)
	if (locale === "it") return it_loading_lists(inputs)
	if (locale === "ru") return ru_loading_lists(inputs)
	if (locale === "es") return es_loading_lists(inputs)
	if (locale === "zh-CN") return zh_cn2_loading_lists(inputs)
	if (locale === "ja") return ja_loading_lists(inputs)
	if (locale === "hi") return hi_loading_lists(inputs)
	if (locale === "pt-PT") return pt_pt2_loading_lists(inputs)
	return en_loading_lists(inputs)
});